// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class I16 implements flatbuffers.IUnpackableObject<I16T> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): I16 {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsI16(bb: flatbuffers.ByteBuffer, obj?: I16): I16 {
    return (obj || new I16()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsI16(bb: flatbuffers.ByteBuffer, obj?: I16): I16 {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new I16()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  value(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  static startI16(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addValue(builder: flatbuffers.Builder, value: number) {
    builder.addFieldInt16(0, value, 0);
  }

  static endI16(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createI16(builder: flatbuffers.Builder, value: number): flatbuffers.Offset {
    I16.startI16(builder);
    I16.addValue(builder, value);
    return I16.endI16(builder);
  }

  unpack(): I16T {
    return new I16T(this.value());
  }

  unpackTo(_o: I16T): void {
    _o.value = this.value();
  }

  unpackFields(...fields: string[]): I16T {
    const t = new I16T();
    const fieldSet = new Set(fields);
    if (fieldSet.has("value")) {
      t.value = this.value();
    }
    return t;
  }
}

export class I16T implements flatbuffers.IGeneratedObject {
  constructor(public value: number = 0) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return I16.createI16(builder, this.value);
  }

  clone(): I16T {
    const obj = new I16T();
    obj.value = this.value;
    return obj;
  }

  equals(other: I16T): boolean {
    if (this.value !== other.value) return false;
    return true;
  }
}

export function verifyI16(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 2);
  } finally {
    verifier.popDepth();
  }
}
